<template>
    <div>
        <h1 class="page-title title">{{$t('profile.title.header')}}</h1>
        <div class="alert alert-danger alert-dismissible" role="alert" v-if="message.verifyAuthenticatorFailMsg != null">
            <button type="button" class="close" data-dismiss="alert" aria-label="Close" @click="removeMessage(IConstants.API_MESSAGE_TYPE.ERROR)">
                <span aria-hidden="true">&times;</span>
            </button>
            <div v-html="$t(message.verifyAuthenticatorFailMsg)"></div>
        </div>
        <div v-if="!this.profileState.maskingVerifiedPerSession">
            <span class="verify-authentication-note">{{$t('profile.label.fido.verify.authentication.note')}}</span>
            <verify-authentication screenNameProps="CUSTOMER_INFO"/>
        </div>
        <h4 class="title box-title"></h4>
        <div class="page-ct">
            <div class="section">
                <div class="box-ct">
                    <div v-if="message">
                        <div class="alert alert-danger alert-dismissible" role="alert" v-if="message.errorMessage != null">
                            <button type="button" class="close" data-dismiss="alert" aria-label="Close" @click="removeMessage(IConstants.API_MESSAGE_TYPE.ERROR)">
                                <span aria-hidden="true">&times;</span>
                            </button>
                            <div v-html="$t(message.errorMessage)"></div>
                        </div>
                        <div class="alert alert-warning" role="alert" v-if="message.warnMessage != null">
                            <button type="button" class="close" data-dismiss="alert" aria-label="Close" @click="removeMessage(IConstants.API_MESSAGE_TYPE.WARNING)">
                                <span aria-hidden="true">&times;</span>
                            </button>
                            <div v-html="$t(message.warnMessage)"></div>
                        </div>
                        <div class="alert alert-success alert-dismissible" role="alert" v-if="message.successMessage != null">
                            <button type="button" id="btn-close" class="close" data-dismiss="alert" aria-label="Close" @click="removeMessage(IConstants.API_MESSAGE_TYPE.SUCCESS)">
                                <span aria-hidden="true">&times;</span>
                            </button>
                            <div id="success-message" v-html="$t(message.successMessage)"></div>
                        </div>
                    </div>
                    <template v-if="this.profileState.isCorporation">
                        <EditProfileCorporation
                                :storeState="this.profileState"
                                :maskingVerifiedPerSession="this.profileState.maskingVerifiedPerSession"
                                @onMessage="handleMessage"
                                @onComplete="handleComplete">
                        </EditProfileCorporation>
                    </template>
                    <template v-else>
                        <EditProfileIndividual
                                :storeState="this.profileState"
                                :maskingVerifiedPerSession="this.profileState.maskingVerifiedPerSession"
                                @onMessage="handleMessage"
                                @onComplete="handleComplete">
                        </EditProfileIndividual>
                    </template>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import {createNamespacedHelpers} from "vuex";
    import * as EDIT_PROFILE_TYPE from '@/store/modules/edit-profile/type'
    import EditProfileCorporation from './EditProfileCorporation.vue';
    import EditProfileIndividual from './EditProfileIndividual.vue';
    import {GET_HEADER_INFO, MENU_HOME, SET_ACTIVE_TAB_ID} from '@/store/modules/header/type';
    import $ from "jquery";
    import ModalPlugin from "@/common/plugins/ModalPlugin.js";
    import IConstants from '@/common/constants/IConstants';
    import VerifyAuthentication from "@/common/mixins/VerifyAuthentication";

    const {mapActions: mapHeaderActions} = createNamespacedHelpers("header");
    const {mapActions, mapState: mapProfileState} = createNamespacedHelpers("editProfile");
    const { mapMutations: mapNewsMutations} = createNamespacedHelpers("news");

export default {
    components: {VerifyAuthentication, EditProfileCorporation, EditProfileIndividual},
    mixins: [],
    data() {
        return {
            message: {
                errorMessage: null,
                warnMessage: null,
                successMessage: null,
                verifyAuthenticatorFailMsg: null
            },
        }
    },
    computed: {
        ...mapProfileState({
            profileState: state => state,
        }),
    },
    async created() {
        this[SET_ACTIVE_TAB_ID](MENU_HOME);
        this[GET_HEADER_INFO]();
        const profileService = this.$service.getService('profile');
        const data = await profileService.getAmsCustomerInfo(IConstants.ACTIVE_MASKING.YES);
        await this[EDIT_PROFILE_TYPE.INIT_PROFILE_INFO](data);
        if (data.warnMessage) {
            this.message.warnMessage = data.warnMessage;
        }
    },
    mounted() {
        $('.btn-cancel.btn-sm').trigger('click');
        this.listenEvents()
    },
    beforeDestroy() {
        this.unListenEvents()
    },
    methods: {
        ...mapHeaderActions([SET_ACTIVE_TAB_ID, GET_HEADER_INFO]),
        ...mapActions([EDIT_PROFILE_TYPE.INIT_PROFILE_INFO]),
        ...mapNewsMutations([
            'updateFields'
        ]),
        handleComplete(data) {
            this[EDIT_PROFILE_TYPE.INIT_PROFILE_INFO](data);
        },
        removeMessage(messageType) {
            this.handleMessage(null, messageType);
        },
        handleMessage(message, messageType) {
            this.message = {};
            const {IConstants} = this;
            switch (messageType) {
                case IConstants.API_MESSAGE_TYPE.ERROR:
                    this.message = {...this.message, errorMessage: message};
                    break;
                case IConstants.API_MESSAGE_TYPE.SUCCESS:
                    this.message = {...this.message, successMessage: message};
                    break;
                case IConstants.API_MESSAGE_TYPE.WARNING:
                    this.message = {...this.message, warnMessage: message};
                    break;
            }
        },
        listenEvents() {
            ModalPlugin.EventBus.$on(IConstants.EVENT_NAME.SHOW_PROFILE_MESSAGE, params => {
                this.message.successMessage = params.message.successMessage;
                this.message.warnMessage = params.message.warnMessage;
                this.message.errorMessage = params.message.errorMessage;
                this.message.verifyAuthenticatorFailMsg = params.message.verifyAuthenticatorFailMsg;
                if (params.callBackFunc) params.callBackFunc()
            });
        },
        unListenEvents() {
            ModalPlugin.EventBus.$off(IConstants.EVENT_NAME.SHOW_PROFILE_MESSAGE);
        }
    },
}
</script>
<style scoped>
#btn-close {
    width: 10%;
}

#success-message {
    width: 90%;
}
</style>
